import { IIssueTrackingProject, IProject } from '../../../shared/interfaces/project.interface';
import { SharedCommonUtility } from '../../../shared/utils/common.utility';
import { $project, ProjectStatus } from '../../../shared/constants/project';
import { $issueIntegrationType } from '../../../shared/constants/issue-tracking';

const NAME_ONLY_INTEGRATION_TYPES: Set<$issueIntegrationType> = new Set<$issueIntegrationType>([
  $issueIntegrationType.github,
  $issueIntegrationType.gitlab,
]);

export class ProjectUtility {
  public static getFormattedIntegrationName(project: IProject, integrationType?: $issueIntegrationType): string {
    const integrationProject: IIssueTrackingProject = project?.[$project.issueIntegrationProject];
    if (SharedCommonUtility.isNullish(integrationProject)) {
      return '';
    }

    const name: string = integrationProject[$project.issueIntegrationProjectName];
    const key: string = integrationProject[$project.issueIntegrationProjectKey];

    if (SharedCommonUtility.isNullishOrEmpty(key) || NAME_ONLY_INTEGRATION_TYPES.has(integrationType)) {
      return name;
    }

    return `${name} (${key})`;
  }

  /**
   * Creates a shallow copy of a filtered portion of a given projects array
   * @param projects projects array
   */
  public static getActiveProjects(projects: IProject[]): IProject[] {
    if (SharedCommonUtility.isNullishOrEmpty(projects)) {
      return [];
    }

    return projects.filter((project: IProject) => project[$project.status] === ProjectStatus.active);
  }
}
